import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import {
  Box,
  Fab,
  IconButton,
  Button as MuiButton,
  Tooltip,
} from "@mui/material";
import { useInfiniteHits } from "react-instantsearch";

import { forwardRef } from "react";

const Button = forwardRef((props, ref) => {
  if (props?.variant === "contained") {
    return <MuiButton variant="contained" {...props} ref={ref} />;
  } else if (props?.variant === "loading-contained") {
    return <MuiButton variant="contained" {...props} ref={ref} />;
  } else if (props?.variant === "loading-outlined") {
    return <MuiButton variant="outlined" {...props} ref={ref} />;
  } else if (props?.variant === "text") {
    return <MuiButton variant="outlined" {...props} ref={ref} />;
  } else {
    return <MuiButton variant="outlined" {...props} ref={ref} />;
  }
});

export const ToggleButton = forwardRef(
  ({ active, onToggle, ...props }, ref) => {
    const toggle = () => {
      onToggle && onToggle(!active);
    };

    return (
      <Button
        {...props}
        ref={ref}
        onClick={toggle}
        endIcon={
          active && <CheckCircleIcon color="secondary" sx={{ scale: "0.8" }} />
        }
      ></Button>
    );
  },
);

export const IconOrLongButton = forwardRef(
  ({ selected, endIcon, ...props }, ref) => {
    return (
      <>
        <Button
          ref={ref}
          {...props}
          color={selected ? "secondary" : undefined}
          variant={selected ? "contained" : undefined}
          sx={{ ...props.sx, display: { xs: "none", md: "inline-flex" } }}
          endIcon={endIcon}
        >
          <Tooltip title={props.title}>
            <>{props.children}</>
          </Tooltip>
        </Button>
        <IconButton
          ref={ref}
          {...props}
          sx={{
            backgroundColor: selected ? "secondary.main" : undefined,
            color: selected ? "white" : undefined,
            "&:hover": {
              backgroundColor: selected ? "secondary.main" : undefined,
            },
            ...props.sx,
            display: { xs: "inline-flex", md: "none" },
          }}
        >
          {endIcon ?? "IconIsMissing"}
        </IconButton>
      </>
    );
  },
);

export const TypesenseInfiniteScrollButton = forwardRef(({ ...props }, ref) => {
  const { isLastPage, showMore } = useInfiniteHits();

  return (
    !isLastPage && (
      <Box justifyContent="center" alignItems="center" display={"flex"} p={2}>
        <Button ref={ref} variant="text" onClick={showMore} {...props}>
          Load more
        </Button>
      </Box>
    )
  );
});

export const EditButton = ({ onClick, children, ...props }) => {
  return (
    <Fab
      color="primary"
      aria-label="edit"
      sx={{ position: "absolute", right: "20px", scale: "0.6" }}
      size="small"
      onClick={onClick}
    >
      <EditSharpIcon />
    </Fab>
  );
};

export default Button;
